import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LogService, ServiceRouter } from '@pershing/pershing-core';
import { IconsServiceDefinition } from './icons-service-definition';
import { Observable } from 'rxjs';

@Injectable()
export class NxiMobileService {

    isOpen: boolean = false;
    serviceUrl: string;
    isMobileMenuTabClickEvent: boolean = false;

    @Output() change: EventEmitter<boolean> = new EventEmitter();

    constructor(private http: HttpClient, private logService: LogService, private serviceRouter: ServiceRouter) {
        logService.info('nxi mobile service : constructor Initializing');
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(IconsServiceDefinition.getInstance());
    }

    toggle() {
        this.isOpen = !this.isOpen;
        this.change.emit(this.isOpen);
    }

    // This is to help sidenav Hostlistener to discern more granually if the click is from
    // within the 'Menu' tab itself.
    mobileMenuTabClickEvent(menuTabClick: boolean) {
        this.isMobileMenuTabClickEvent = menuTabClick;
    }

    public checkExtendedHour(): Observable<any> {
        return this.http.get(this.serviceUrl + '/trading-rest/check-extended-hour');
    }
}
